( function( $ ) {

  $(document).foundation();

})( jQuery );
